import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { RESERVATIONS_BOOKINGS_PATH } from '@/pages/reservations/reservations.constants'

import { NAVIGATION_LABELS } from '../../../helpers/constants'
import NavigationLabel from '../../NavigationLabel/NavigationLabel'

const AmenityReservationsLink = ({ withUpsellingRedirect }) => {
  const { t } = useTranslation(['navbar'])

  return (
    <div className="hover-menu-item">
      <NavLink
        className={({ isActive }) =>
          isActive ? 'navmgr-item__link--active' : 'hover-menu-item__link'
        }
        to={
          withUpsellingRedirect
            ? '/dashboard/upselling/amenityReservations'
            : RESERVATIONS_BOOKINGS_PATH
        }
      >
        <span>
          {t('navbar:upsellingLinks.reservations')}
          <NavigationLabel type={NAVIGATION_LABELS.HIDDEN} locked={withUpsellingRedirect} />
        </span>
      </NavLink>
    </div>
  )
}

AmenityReservationsLink.propTypes = {
  withUpsellingRedirect: PropTypes.bool,
}

export default AmenityReservationsLink
